var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-card-header"},[_c('div',{staticClass:"v-card-header__title"},[_vm._t("title")],2),(_vm.$scopedSlots.actions)?_c('div',{staticClass:"v-card-header__actions"},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }